import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import emptyImage from "../../../../../../../../assets/empty.svg";

interface Props {
	cardType: string;
}

export const EmptyDashboard = ({ cardType }: Props) => {
	const { t } = useTranslation("whatif.rootcause");

	return (
		<Stack alignItems={"center"} justifyContent={"center"} spacing={1}>
			<img src={emptyImage} alt="Empty Dashboard" width="80" height="80" />
			<Typography variant="body1" color="text.primary">
				{t(`emptyDashboard/${cardType}/title`)}
			</Typography>
			<Typography variant="body2" color="text.secondary">
				{t(`emptyDashboard/${cardType}/description`)}
			</Typography>
		</Stack>
	);
};
